<template>
  <!--展示-->
  <div class="">
    <header-nav :navInfo="navInfo"
                @backFunc="backFunc"></header-nav>

    <div class="page-body">
      <div class="item-box">
        <van-form ref="formRef"
                  class="form"
                  validate-trigger="onSubmit">
          <van-cell-group inset>
            <van-field v-model="formData.email"
                       name="email"
                       icon-prefix="field-icon"
                       :left-icon="require('@/assets/user/login_phone.png')"
                       placeholder="请输入邮箱号"
                       :rules="rules.email" />

          </van-cell-group>
        </van-form>
      </div>
      <div style="margin: 16px;">
        <div class="submit"
            @click="activationEmail">
          发送验证激活邮箱
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/head-nav'
import { emailPettern } from '@/utils/pattern'
import { sendEmail } from '@/api/user'
import { Notify } from 'vant'

export default {
  name: "index",
  props: ['userData'],
  components: {
    HeaderNav
  },
  data () {
    return {
      navInfo: {
        tit: '邮箱管理'
      },
      rules: Object.freeze({
        email: [
          { required: true, message: '请输入邮箱号码' },
          {
            pattern: emailPettern,
            message: '请输入正确的邮箱号',
          }
        ],
      }),
      formData: {
        email: ''
      }
    }
  },
  methods: {
    // 避免重复激活邮箱
    activationEmail () {
      this.$refs.formRef.validate('email').then(async () => {

        const res = await sendEmail({ email: this.formData.email })
        const resData = res.data
        if (resData.code === 200) {
          Notify({ type: 'success', message: '验证激活邮件已发送至' + this.formData.email + '请进入邮箱激活' });
        }
      })

    },
    backFunc () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="stylus">
.formIcon
  width 24px

.icon-eye
  width 15px
  height 15px

.form
  padding 0 10px

  >>> .van-field__left-icon .field-icon
    font-size 22px

  >>> .van-field__right-icon .field-icon
    font-size 16px

  .get-code-btn
    display inline
    padding 6px 8px
    font-size 10px
    border 1px solid #34D1BC
    border-radius 25px
    color #34D1BC
    background #fff
    cursor pointer

.submit
  width 240px
  height 40px
  color #fff
  font-size 14px
  margin 0 auto
  text-align center
  line-height 40px
  background rgba(52, 209, 188, 1)
  box-shadow 0px 2px 6px 0px rgba(52, 209, 188, 0.2)
  border-radius 20px
</style>